export const SLIDESHOW_FETCH_PNMS = 'SLIDESHOW_FETCH_PNMS';
export const SLIDESHOW_FETCH_PNMS_INIT = 'SLIDESHOW_FETCH_PNMS_INIT';
